/* eslint-disable @typescript-eslint/no-explicit-any */
// todo: fix type later
export const notNull = (val: any) => val !== null;
export const notBlank = (val: any) => notNull(val) && val !== "";
export const isPhoneNumber = (val: any) =>
  notNull(val) && val.match(/^\+?[\d .-]{7,}(x[\d .-]+)?$/);
